export default __webpack_public_path__ + "static/media/screeningReject.a34667d8.png";